<template>
  <div class="page-panel">
    <div class="page-panel__header">
      <div class="page-panel-header__control">
        <el-button class="page-panel-header-control-button" size="mini" type="primary">预览</el-button>
        <el-button class="page-panel-header-control-button" size="mini" type="primary" @click="back">返回</el-button>
      </div>
      <div class="page-panel-header__title">行业动态</div>
    </div>
    <div class="page-panel__body">
      <el-form ref="form" label-width="90px">
        <el-form-item label="新闻标题">
          <el-input v-model="newsParam.newsTitle" placeholder="请输入新闻标题"></el-input>
        </el-form-item>
        <el-form-item label="副标题">
          <el-input v-model="newsParam.newsSubtitle" placeholder="请输入新闻副标题"></el-input>
        </el-form-item>
        <el-form-item label="作者">
          <el-input v-model="newsParam.newsAuthor" placeholder="请输入作者"></el-input>
        </el-form-item>
        <el-form-item label="新闻分类">
          <el-radio-group v-model="newsParam.newsCategory">
            <el-radio v-for="item in newsClassification" :key="item.itemId" :label='item.itemId'>{{item.itemName}}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="新闻封面">
          <el-upload action="/file/upload" list-type="picture-card" :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove" auto-upload="false" :on-change='changeUpload'>
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
        <el-form-item label="文章编辑">
          <ueditor :config="editorConfig" v-model="newsParam.newsText"></ueditor>
        </el-form-item>
        <el-form-item label="标签/关键字">
          <new-tag :dynamicTags='dynamicTags' v-model="newsParam.newsTarget"></new-tag>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-radio-group>
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="article_footer_control">
        <el-button type="primary" @click="addNews">发布</el-button>
      </div>
    </div>
    <el-dialog title="图片剪裁" :visible.sync="dialogVisible1" append-to-body>
      <div class="cropper-content">
        <div class="cropper" style="text-align:center">
          <vueCropper ref="cropper" :img="option.img" :outputSize="option.size" :outputType="option.outputType"
            :info="true" :full="option.full" :canMove="option.canMove" :canMoveBox="option.canMoveBox"
            :original="option.original" :autoCrop="option.autoCrop" :fixed="option.fixed"
            :fixedNumber="option.fixedNumber" :centerBox="option.centerBox" :infoTrue="option.infoTrue"
            :fixedBox="option.fixedBox" @realTime="realTime"></vueCropper>
        </div>
        <div>
          <span>裁剪比例</span>
          <el-button type="primary">1 : 1</el-button>
          <el-button type="primary">7 : 5</el-button>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="finish" :loading="loading">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { sessionStorage } from '@/common/util/storage';
import * as newsApi from '@/api/industryIdynamics';
export default {
  data() {
    return {
      dialogVisible1: false,
      // 裁剪组件的基础配置option
      option: {
        img: '', // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: 'png', // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        // autoCropWidth: 300, // 默认生成截图框宽度
        // autoCropHeight: 200, // 默认生成截图框高度
        fixedBox: false, // 固定截图框大小 不允许改变
        fixed: false, // 是否开启截图框宽高固定比例
        fixedNumber: [4, 1], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
      picsList: [],
      // 防止重复提交
      loading: false,
      newsClassification: sessionStorage.get('getdiclist2'),
      newsParam: {
        newsCategory: 3
      },
      dialogImageUrl: '',
      dialogVisible: false,
      dynamicTags: [],
      // 富文本框初始化
      editorConfig: {
        initialFrameWidth: 900,
        initialFrameHeight: 300,
        zIndex: 0
      }
    };
  },
  methods: {
    changeUpload(file, fileList) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过 5MB!');
        return false;
      }
      this.fileinfo = file;

      // 上传成功后将图片地址赋值给裁剪框显示图片
      this.$nextTick(() => {
        this.option.img = file.url;
        this.dialogVisible1 = true;
      });
    },
    addNews() {
      newsApi.addNews(this.newsParam).then(res => {});
    },
    back() {
      this.$router.push({
        path: '/admin/industryIdynamics'
      });
    },
    handleRemove(file) {
      console.log(file);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }
  },
  created() {}
};
</script>
<style lang="stylus" scoped>
.cropper-content {
  .cropper {
    width auto
    height 300px
  }
}
.el-tag + .el-tag {
  margin-left 10px
}
.button-new-tag {
  margin-left 10px
  height 32px
  line-height 30px
  padding-top 0
  padding-bottom 0
}
.input-new-tag {
  width 90px
  margin-left 10px
  vertical-align bottom
}
</style>



// WEBPACK FOOTER //
// src/pages/adminPage/test/testAvatar.vue